import React, { useEffect } from 'react';
import AboutTab from './AboutTab';
import ForumTab from './ForumTab';
import HostsGuestsTab from './HostsGuestsTab';
import MediaTab from './MediaTab';
import FilesTab from './FilesTab';
import './EventTabs.css';

const tabComponents = {
  about: AboutTab,
  forum: ForumTab,
  hostsGuests: HostsGuestsTab,
  media: MediaTab,
  files: FilesTab,
};

const tabLabels = [
  { id: 'about', label: 'About' },
  { id: 'forum', label: 'Forum' },
  { id: 'hostsGuests', label: 'Hosts & Guests' },
  { id: 'media', label: 'Media' },
  { id: 'files', label: 'Files' },
];

const EventTabs = ({
  event,
  activeTab,
  setActiveTab,
  hosts,
  guests,
  attendees,
  loadingAttendees,
  userProfile,
  supabase,
  creatorProfile,
  userAttendanceStatus,
  onAttendanceChange,
}) => {
  const isMember = !!userAttendanceStatus;

  // Ensure non-attendees cannot navigate away from About
  useEffect(() => {
    if (!isMember && activeTab !== 'about') {
      setActiveTab('about');
    }
  }, [isMember, activeTab, setActiveTab]);

  const TabComponent = tabComponents[activeTab] || AboutTab;
  
  // Prepare props based on which tab is active
  const getTabProps = () => {
    switch(activeTab) {
      case 'hostsGuests':
        return { event, hosts, guests, attendees, loadingAttendees };
      case 'forum':
        return { eventId: event?.id, userProfile, supabase };
      case 'about':
        return { event, creatorProfile, userProfile, userAttendanceStatus, onAttendanceChange };
      default:
        return { event };
    }
  };
  
  return (
    <div className="event-tabs">
      <nav className="event-tabs-nav">
        {tabLabels
          .filter(tab => (isMember ? true : tab.id === 'about'))
          .map(tab => (
            <button
              key={tab.id}
              className={`event-tab-btn${activeTab === tab.id ? ' active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
      </nav>
      <div className="event-tab-content">
        <TabComponent {...getTabProps()} />
      </div>
    </div>
  );

};

export default EventTabs;